import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

export const PARAMETRES = {
  [PARAMETRES_KEYS.marque]: {
    element: 'une marque',
    titleCreate: 'Créer une marque',
    libelleChamp: 'Nom de la marque',
  },
  [PARAMETRES_KEYS.materielType]: {
    element: 'un materiel',
    titleCreate: 'Créer un materiel',
    libelleChamp: 'Nom du materiel',
  },
  [PARAMETRES_KEYS.materielFormat]: {
    element: 'un format',
    titleCreate: 'Créer un format',
    libelleChamp: 'Nom du format',
  },
};